import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-monthpicker', 'months', [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]);
Labels.set('ui-monthpicker', 'year', 'Year');
Labels.set('ui-monthpicker', 'month', 'Month');
Labels.set('ui-monthpicker', 'clearDate', 'Clear date');
